// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteDepartmentMutationVariables = Types.Exact<{
  deleteDepartmentId: Types.Scalars['ID']['input'];
}>;

export type DeleteDepartmentMutation = { __typename?: 'Mutation' } & Pick<Types.Mutation, 'deleteDepartment'>;

export const DeleteDepartmentDocument = /*#__PURE__*/ gql`
    mutation DeleteDepartment($deleteDepartmentId: ID!) {
  deleteDepartment(id: $deleteDepartmentId)
}
    `;
export type DeleteDepartmentMutationFn = Apollo.MutationFunction<
  DeleteDepartmentMutation,
  DeleteDepartmentMutationVariables
>;

/**
 * __useDeleteDepartmentMutation__
 *
 * To run a mutation, you first call `useDeleteDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDepartmentMutation, { data, loading, error }] = useDeleteDepartmentMutation({
 *   variables: {
 *      deleteDepartmentId: // value for 'deleteDepartmentId'
 *   },
 * });
 */
export function useDeleteDepartmentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(
    DeleteDepartmentDocument,
    options,
  );
}
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = Apollo.BaseMutationOptions<
  DeleteDepartmentMutation,
  DeleteDepartmentMutationVariables
>;
